exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".custom-select-select {\n  min-width: 200px; }\n  .custom-select-select::after {\n    border-bottom: 2px solid #777777 !important; }\n\nlabel.custom-select-label {\n  color: #777777  !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/basic/CustomSelect/index.scss
// module id = 1228
// module chunks = 0